import React from 'react'
import { WKOperation } from '../../components/wk'
import { browserHistory } from 'react-router'
import axios from 'axios'
import { Dialog, Toast } from 'react-weui'
import pushImg from '../../images/lecture/push-lecture.png'


class ScheduleDetailOperation extends React.Component {
    constructor (props) {
        super(props)
        this.pushSingleBtn = [
            { label: '好', onClick: e => this.setState({ isShowPushDialog: false }) }
        ]
        this.pushMultipleBtn = [
            { label: '取消', type: 'default', onClick: e => this.setState({ isShowPushDialog: false }) },
            { label: '推送', onClick: e => this.onClickPush() },
        ]
        this.state = {
            isShowPushDialog: false,
            checkPush: {},
            isShowPushSuccessToast: false,
            isChecking: false,
            checkPushOrigin: {},
        }
    }
    onClickPush () {
        this.showPushSuccessToast()
        this.setState({ isShowPushDialog: false })
        axios.post(`/api/schedule/${this.props.id}/push`)
            .then(res => {
                if (res.data.code !== 0) {
                    alert(res.data.msg)
                }
            })
    }
    fetchCheckPush () {
        this.setState({ isChecking: true })
        axios.post(`/api/schedule/${this.props.id}/check_push`)
            .then(res => {
                this.setState({ checkPush: res.data.data, isChecking: false, checkPushOrigin: res.data })
            })
    }
    renderEditList() {
        return [
            {
                blockContent: {
                    img: pushImg,
                    text: '打卡推送',
                    method: () => this.onClickOperaPush()
                },
                hasContent: true
            },
        ]
    }
    onClickOperaPush () {
        this.fetchCheckPush()
        this.setState({ isShowPushDialog: true })
    }
    showPushSuccessToast () {
        this.setState({ isShowPushSuccessToast: true })
        setTimeout(() => {
            this.setState({ isShowPushSuccessToast: false })
        }, 2000)
    }
    getPushDialogTitle (checkPush, isChecking, checkPushOrigin) {
        if (isChecking) {
            return '正在检查推送...'
        }
        if (checkPush.push_time == null) {
            return '不可推送'
        }
        return checkPush.push_time > 0 ? `还剩${checkPush.push_time}次推送机会` : '推送机会已用完'
    }
    render() {
        const { checkPush } = this.state
        return (
            <div className="operation">
                <Dialog 
                    type="ios" 
                    title={this.getPushDialogTitle(checkPush, this.state.isChecking, this.state.checkPushOrigin)} 
                    buttons={checkPush.can_push ? this.pushMultipleBtn : this.pushSingleBtn} 
                    show={this.state.isShowPushDialog}
                >
                    <div className="text-left">
                        {checkPush.msg || this.state.checkPushOrigin.msg}
                    </div>
                </Dialog>
                <WKOperation editList={this.renderEditList()} />
                <Toast icon="success-no-circle" show={this.state.isShowPushSuccessToast}>推送成功</Toast>
            </div>
        )
    }
}

export default ScheduleDetailOperation


// WEBPACK FOOTER //
// ./src/pages/schedule/ScheduleDetailOperation.js